<template>
  <div class="feedback-wrapper">
     <div class="m-b-40">
       <h3 class="m-b-10">Design Draft Feedback</h3>
       
       <p>Your feedback is valuable to us. It helps us improve our work. Please take some time to rate our work.</p>
     </div>
     <section class="star-rating m-b-30">
        <label class="customLabel" for="">Rate our work </label>
        <star-rating v-model="rating"  :star-size="35"  :increment="0.5" text-class="custom-text"></star-rating>
     </section>
     <section class="m-b-30">
        <label class="customLabel">Question : {{question}}  </label>
         <b-form-radio-group
            id="radio-group-1"
            v-model="selected"
            :options="options"
            name="radio-options"
            stacked
          ></b-form-radio-group>
     </section>
     <section class="m-b-30">
        <label class="customLabel" for="">Comment :</label>
        <b-form-textarea
          id="textarea"
          v-model="comment"
          placeholder="Enter your comments"
          rows="16"
          max-rows="6"
        ></b-form-textarea>
     </section>
     <section>
        <b-btn size="lg" block variant="primary" @click="addDraftFeedback">SUBMIT FEEDBACK</b-btn>
     </section>
  </div>
</template>

<script>
import StarRating from 'vue-star-rating';
import CustomerDraftsService from '../../../services/customer-drafts.service';
import EventBus from '../../../EventBus';
  export default {
    props: {
      hashCode: {
        type: String,
        default: ''
      }
    },
    data(){
      return {
        rating: 0,
        question: 'How satisfied were you with the design ?',
        selected: '',
        options: [
          { text: 'Satisfied ', value: 'Satisfied ' },
          { text: 'Neutral ', value: 'Neutral ' },
          { text: 'Dissatisfied ', value: 'Dissatisfied ' },
        ],
        comment: ''
      }
    },
    components: {StarRating},
    mounted(){
      document.body.style.backgroundColor = `#f0f2f5`;
    },
    methods: {
      async addDraftFeedback(){

        if(!this.rating && !this.selected && !this.comment){
           this.$toasted.show("Please fill at least one field.", {
                type: "error",
                position: 'top-center',
                action: {
                  text: "Close",
                  class: "toastBtnTxt",
                  onClick: (e, toastObject) => {
                    toastObject.goAway(0);
                  },
                },
                duration: 5000,
          });
          return
        }
        try{
          let data = {
            rating: this.rating,
            designSatisfaction: this.selected,
            comment: this.comment,
            hash: this.hashCode
          }
          const result = await CustomerDraftsService.addDraftFeedback(data);

          EventBus.$emit('draft-feedback-given-by-customer')

          this.$toasted.show(result.data.message, {
                type: "success",
                position: 'top-center',
                action: {
                  text: "Close",
                  class: "toastBtnTxt",
                  onClick: (e, toastObject) => {
                    toastObject.goAway(0);
                  },
                },
                duration: 5000,
          });

        }catch(errors){
          console.log(errors)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>

 .feedback-wrapper{
    max-width: 620px;
    margin: 30px auto;
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .1), 0 8px 16px rgba(0, 0, 0, .1);
    padding: 30px;
  }
  .customLabel{
    font-size: 16px;
    font-weight: 600;
    display: block;
    margin-bottom: 15px;
  }
  .mandatory{
    font-size: 22px;
    color: red;
  }
</style>